/** 带遮罩层loading */
import {Message, Loading} from 'element-ui';

/**
 * 全局带遮罩层loading
 * @param options
 * 
 * 使用：
 *   const loading = this.$messageLoading({
 *     message: '正在加载中..'
 *   })
 *   loading.close()
 * 
 */
export default function (options) {
  if (typeof options === 'string') {
    options = {message: options};
  }
  const loading = Loading.service({
    spinner: 'none',
    background: options.background ? options.background : 'rgba(0, 0, 0, .15)' // 如果不想要透明背景的话 可以传：transparent 
  });
  return Message(Object.assign({
    duration: 0,
    customClass: 'yld-message-loading'
  }, options, {
    onClose: (ins) => {
      loading.close();
      options.onClose && options.onClose(ins);
    }
  }));
}
